import React from 'react';
import { Box } from '@mui/system';

export function SectionContainer({ children }) {
    return (
        <Box marginBottom={{ xs: "28px", sm: "80px" }}>{children}</Box>
    );
}
